import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { paymentService } from '../services/paymentService';

export const usePaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(false);
  const [result, setResult] = useState<{
    success: boolean;
    message: string;
    error?: string;
  } | null>(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    const paymentStatus = searchParams.get('payment');

    if (sessionId && paymentStatus === 'success') {
      handlePaymentSuccess(sessionId);
    } else if (paymentStatus === 'cancelled') {
      setResult({
        success: false,
        message: 'Payment was cancelled'
      });
    }
  }, [searchParams]);

  const handlePaymentSuccess = async (sessionId: string) => {
    setIsProcessing(true);
    try {
      console.log('🔍 Processing payment success for session:', sessionId);
      
      const paymentResult = await paymentService.handlePaymentSuccess(sessionId);
      
      if (paymentResult.success) {
        setResult({
          success: true,
          message: paymentResult.paymentType === 'export_override' 
            ? 'Export purchased successfully! You can now export your signature.'
            : 'Subscription activated successfully! You now have access to premium features.'
        });
        
        // Clear the URL parameters
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        setResult({
          success: false,
          message: 'Payment verification failed',
          error: paymentResult.error
        });
      }
    } catch (error) {
      console.error('❌ Error processing payment success:', error);
      setResult({
        success: false,
        message: 'Failed to process payment success',
        error: error instanceof Error ? error.message : 'Unknown error'
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    isProcessing,
    result,
    clearResult: () => setResult(null)
  };
}; 